import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialUserSettingsState from './user-settings-initial-state';
import { NotificationPreferences } from '../models/notification-preferences.model';

const userSettingsSlice = createSlice({
    name: 'userSettingsSlice',
    initialState: initialUserSettingsState,
    reducers: {
        setTotalUser(state, { payload }: PayloadAction<number>) {
            state.count = payload;
        },
        setNotificationPreferences(state, { payload }: PayloadAction<NotificationPreferences | null>) {
            state.notificationPreferences = payload;
        }
    }
});

export const {
    setTotalUser,
    setNotificationPreferences
} = userSettingsSlice.actions

export default userSettingsSlice.reducer
